// extracted by mini-css-extract-plugin
export default {"container":"container__BNS7p","iconContainer":"iconContainer__w64-V","title":"title__3do+d","description":"description__--TTX","settings":"settings__0gHzB"};